import React from "react";
import CustomTooltip from "components/CustomTooltip";
import { BiSolidInfoCircle } from "react-icons/bi";
import { Notification } from "../../../nodeParamenters.model";
import "./style.scss";

type Props = {
  impactNotifications: Notification[];
};

const notificationTypeMessages: Record<string, string> = {
  IMPACT_EVALUATION_DEADLINE_START: "Notifica o gestor quando a avaliação estiver disponível.",
  IMPACT_EVALUATION_DEADLINE_END: "Lembra o gestor no último dia do prazo, às 09h.",
};

const InfoComponent: React.FC<Props> = ({ impactNotifications }) => (
  <div className="info-component">
    <CustomTooltip
      title={
        <div className="tooltip-content">
          {impactNotifications.map((notification, idx) => (
            <React.Fragment key={notification.idNotification}>
              <div className="tooltip-section">
                <strong>{notification.description}</strong>
                <span>
                  {notificationTypeMessages[notification.type] || ""}
                </span>
              </div>
              {idx < impactNotifications.length - 1 && (
                <div className="tooltip-divider" />
              )}
            </React.Fragment>
          ))}
        </div>
      }
      placement="top"
      arrow
      enterTouchDelay={0}
    >
      <span className="info-icon" tabIndex={0} aria-label="Informações sobre notificações">
        <BiSolidInfoCircle />
      </span>
    </CustomTooltip>
    Enviar notificações sobre as atividades abaixo quando
  </div>
);

export default InfoComponent;
